export async function initFootnotePopup(container) {
  if (!container) {
    return;
  }
  let footnoteList = container.querySelectorAll('.legalinfo');
  for (let i = 0, len = footnoteList.length; i < len; i++) {
    const { default: Alert } = await import('../classes/alertClass');
    footnoteList[i].addEventListener('click', (e) => {
      e.preventDefault();
      let alert = new Alert({
        mainClass: 'footnote-popup',
        containerSelector: '.alerts',
        text: e.currentTarget.innerHTML,
        closeButtons: true
      });
      alert.setVisible(true);
    });
  }
  removeFootnoteNotAllowedCountry(container);
}

function removeFootnoteNotAllowedCountry(container) {
  if (!container) {
    return;
  }
  const elements = container.querySelectorAll('span[data-allowed-country]');
  elements?.forEach((el) => {
    const country = el.getAttribute('data-allowed-country');
    if (country != _CMS_USERIP) {
      el.remove();
    }
  });
}
